import { useState }  from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

import axios from 'axios';

import styles from './Login.module.css';

import InputForm from '../../components/InputForm';
import Title from '../../components/Title';
import Logo from '../../assets/logo.png';
import Button from '../../components/Button';
import ButtonLink from '../../components/ButtonLink';

export default function Login({ type }) {
  const navigate = useNavigate();
  const { loginContext } = useAuth();
  const [login, setLogin] = useState({
    email: '',
    senha: '',
  });
  
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLogin({
      ...login,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!login.email || !login.senha) {
      setErrorMessage('Por favor, preencha todos os campos.');
      return;
    }

    const url = type === 'admin'
      ? 'https://back-cultura-sje-production.up.railway.app/auth/login/admin'
      : type === 'author'
        ? 'https://back-cultura-sje-production.up.railway.app/auth/login/author'
        : null;

    if (!url) {
      setErrorMessage('Tipo de login inválido.');
      return;
    }
    
    axios.post(url, login)
      .then((response) => {
        const { accessToken } = response.data;
        if (accessToken) {
          localStorage.setItem('accessToken', accessToken);
          loginContext(accessToken);
          navigate(type === 'admin' ? '/painel-administrativo' : type === 'author' ? '/autores/painel' : '');
        } else {
          setErrorMessage('Erro ao processar o login.');
        }
      })
      .catch((error) => {
        setErrorMessage('E-mail ou senha incorretos.');
      })
  }

  return (
    <div className={styles.container}>
      <div className={styles.loginContiner}>
        <div className={styles.imageContainer}>
          <img src={Logo} alt="Logo da prefeitura" />
          <h3>{ type === 'admin' ? 'ÁREA ADMINISTRATIVA' : type === 'author' ? 'ÁREA DO AUTOR' : ''} - SECRETARIA DE CULTURA</h3>
        </div>
        <div className={styles.formContainer}>
          <form onSubmit={handleSubmit} className={styles.loginForm}>
            <Title color='var(--brown-300)'>Login</Title>
            <InputForm
              mode='input'
              type='email'
              title='Email'
              name='email'
              placeholder='Digite seu e-mail'
              value={login.email}
              onChange={handleChange}
              marginBottom='0'
            />
            <InputForm 
              mode='input'
              type='password'
              title='Senha'
              name='senha'
              placeholder='Digite sua senha'
              value={login.senha}
              onChange={handleChange}
              marginBottom='0'
            />
            <Button>Entrar</Button>
              {type === 'author' ? <ButtonLink type='type2' path='/autores/cadastro-de-autores'>Cadastre-se</ButtonLink> : ''}
          </form>
          {errorMessage && <p className={styles.errorMessage}>{errorMessage}</p>}
        </div>
      </div>
    </div>
  )
}
